import '@ant-design/compatible/assets/index.css';
import { Form } from '@ant-design/compatible';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import FloorEditor from './editor';

@modal(
  {
    className: 'floor-editor-modal',
  },
  true,
)
class FloorEditorContainer extends React.Component {
  render() {
    const { t } = this.props;

    return (
      <div className="floor-editor">
        <div className="floor-editor__header">
          <div className="floor-editor__header__title">
            {t('cms:cms.property.listing_management.floor_plan.modal.title')}
          </div>
          <CloseOutlined
            className="floor-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <div className="floor-editor__body">
          <FloorEditor
            id={this.props.id}
            floorPlans={this.props.floorPlans}
            onClose={this.props.handleCloseModal}
            onSuccess={this.props.handleOnSuccess}
            form={this.props.form}
          />
        </div>

        <div></div>
      </div>
    );
  }
}

FloorEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  floorPlans: PropTypes.array.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleOnSuccess: PropTypes.func,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
    setFieldsValue: PropTypes.func.isRequired,
    validateFieldsAndScroll: PropTypes.func.isRequired,
    getFieldsValue: PropTypes.func.isRequired,
  }).isRequired,
};

FloorEditorContainer.defaultProps = {
  t: () => {},
  id: '',
  floorPlans: [],
  handleCloseModal: () => {},
  handleOnSuccess: () => {},
  form: {
    getFieldDecorator: () => {},
    setFieldsValue: () => {},
    validateFieldsAndScroll: () => {},
    getFieldsValue: () => {},
  },
};

export default Form.create({
  name: 'floor_plan_editor_modal',
})(FloorEditorContainer);
